export const environment = {
  // Google Workspace sign-in (auth-only). EMPTY until the OAuth clients exist.
  // Empty ⇒ the Google button is not rendered and NOTHING contacts Google. Turning it on is a
  // config change, not a code change. prod2 takes the VeriCure client; every lower env takes
  // VeriCure-test, mirroring the Entra split.
  googleClientId: '',
  // External ID (CIAM) sign-in: email + password accounts in the Vericure customer tenant (c46c90fe).
  // App "VeriCure External (test)", NON-PROD: hybrid-dev (and stg's registration, unused there).
  // DataServices beta-dev must carry the matching ExternalId* settings or every CIAM call is a 401.
  // Empty either value ⇒ no CIAM sign-in and nothing contacts the CIAM authority.
  // Authority on the CUSTOM DOMAIN login.vericure.io (verified + serving, 2026-10-05): the sign-in page and
  // its password-manager entry say vericure.io. Discovery at <authority>/v2.0/.well-known/openid-configuration;
  // the token ISSUER is unchanged (ciamlogin), so DataServices needs no change. knownAuthorities is derived
  // from this host (external-id-sign-in.service.ts).
  externalIdClientId: '633c6a40-03bf-4f03-99da-ccadea03891e',
  externalIdAuthority: 'https://login.vericure.io/c46c90fe-c433-4b5d-8bce-c565928f5b0e',
  // Home-realm discovery for the one-box /login (POST {domain} -> {route}), through the Front Door
  // edge: the edge rate-limits it, and DS refuses calls that skip it (403 edge-required). Absent in
  // every other environment, which then sends every email to the staff sign-in with no request.
  authDiscoverUrl: 'https://vericure-beta-dev-discover-bpbtauakcjc5fzf9.a03.azurefd.net/api/auth/discover',
  production: false,
  redirectUri: 'https://hybrid-dev.vericure.io',
  apiUrl: 'https://func-vericure-dataservices-beta-dev.azurewebsites.net/api/',
  sciChartKey:
    'RwonaaOl54GUn1hvYvzk7y+Seg9KvMUqoMg2AlJ6LAiCleFowCJEeIV/V0LoMqOw6lsZ1IuKzOegYNxUlsX0/X31wKl9hia3JPLQC8mIzr2n5DF7976Kr729lJusmXL2Y6zK5b2SDXvPX0vFXNwOlDgH2vi5/sF7sZqJEbWWyhTy54ov3WQ5SYfXPCNBcdU8JrfiW9qRCP0QufzxnGsoLEyG/sbQWYevty64beIr8bUiYrM7GjergBBBYx+OKWmqdQUdmDKiSUwbq/H4kESjbE0qVikV6Efq2eit9UQjUQLeseGEF5YCU/olOx9WWYR/IfxOYEdQRVosOsti8ZOYAwbGGpyIvk2vxm9zZwJHlPmdwRb5Q22SDFyf4JdGXTROpqV4zJbws/w7zPkr/dSWMeqmCQwMF7wY27EDqjYs9dhHPNxb8f82o6IR7rfKLvE+Q4ppMST9NVEpDhcSqPDPha8DjFr9Ui26P7UPt8Bf1/Ys9z1gQqG79INyS4rc4kbbiLhFXBNlKevjaPxqa0ymA11TXkMN8d+4wTIpMbifA7GU4QyRrzNjL0ou5eWrZdSV7djTB5sqnOE8ahEMeXAN4ig4XiANyrAgFSZDfkMoXX59O/6tI/3+zvYm5uFjE99tfWty1lgqU0hatNpYFYmmCe92LktXF8N99ybOzOc49QMu0zGIFOqGAKUXH2uRkemAdWliqago5nHhH5j15y6hcDYO8NNCVFHC54GhXSAzQlzBPY7YUPeCHjCOBgNEjRiO5yHvpCXUegLn07gkBNL0+oYyYKzPbLFntlm1CNqEUVk14dkyiv0I7UQVq0zmNtulPoUJ010YBFJcC/pcUw5By6RW3rWnBqDC8J3fq13t0EwTM1KYYse7M8k63T8lHp7AFBDukoHUm89hxT+1f8+1CTH6N37VLEbrwPvSX4dGodnKxdMdIEZS1sNmTvih+tr8d4kQyy33FQHzHWu8C5V08Vev2GfsN5LialUSKjEvGzd9duye4Yg=',
  /**
   * Client half of the server's RequireEntraAuth switch. While false, API calls
   * authenticate with the function key only and MSAL is never asked for an API
   * token. Flip to true in lockstep with the server enabling RequireEntraAuth —
   * the function-key parameter keeps being sent either way, so the paths overlap.
   */
  /**
   * 'VeriCure-test' in RedHaw's CSP tenant. DECLARED, not inherited:
   * beta-dev used to rely on api-scope.ts's fallback, which pointed at the now
   * replaced 7371635d. A config that gets its identity from a default is a
   * config nobody notices when the default moves.
   *
   * beta-dev's API accepts BOTH VeriCure and VeriCure-test; prod2 accepts
   * VeriCure alone. So this value is what keeps a beta-dev token from being
   * usable against prod2.
   */
  entraClientId: '2e945b52-de34-4243-a63c-b68cb91c662b',
  requireEntraAuth: true,
  /**
   * Request server-side spatial downsampling (telemetry item 3). While false the
   * client sends no resolution/window params and the API returns full resolution,
   * exactly as before — so this can be flipped independently of the server.
   */

  /**
   * Absolute base for shareable links (alert deep links, copy-link).
   *
   * Empty means "use the running origin", which is right in the browser. It is
   * set explicitly so DataServices and the client agree on the SAME absolute URL
   * when DS emits links into email/Slack, where there is no origin to infer.
   */
  appBaseUrl: 'https://hybrid-dev.vericure.io',

  downsamplingEnabled: true,
  /**
   * Live tick stream over SignalR (telemetry item 4). While false the client never
   * connects and polling behaves exactly as before — so this flips independently
   * of the server's LiveTelemetryEnabled.
   */
  liveTelemetryEnabled: true,
  /**
   * Live project-list push (SignalR `projectChanged` -> refetch GetProjectlist).
   *
   * ON since 2026-09-17. The server half was ALREADY on and had been announcing
   * to nobody: `LiveProjectListPush=true` in the function app's settings, with
   * `PROJECT_ANNOUNCED project='...' customerId=55 group=c-55` in its traces.
   *
   * Verified against the DEPLOYED assembly before flipping, because this file's
   * sibling notes that a wrong event name fails silently and completely:
   *   - route  `live/subscribe-customer` exists (LiveSubscribeCustomer)
   *   - event  literal `projectChanged` is present in Vericure.DataServices.dll
   * Both match DEFAULT_PUSH_CONFIG. (The literals are UTF-16 in a .NET assembly,
   * so an ASCII `strings` pass reads as "absent" — run a positive control.)
   *
   * It is an OPTIMISATION, never a source of truth: with it off, or its socket
   * down, the 45 s quiet refetch in MainLayoutComponent still corrects the list.
   */
  liveProjectListPushEnabled: true,

  /**
   * Quiet project-list refetch cadence, ms. 0/absent = off.
   *
   * THE FLOOR under the push. Restored after a 2026-09-22 bench measurement: the
   * socket stayed open and silent for eleven minutes on a live cure, which
   * reconcile-on-reconnect cannot catch because nothing disconnects.
   */
  projectListRefreshMs: 45000,

  /**
   * Negotiate route / hub / event names — the CONFIRMED DataServices contract
   * (c7db19e). Kept in config so a future change needs no code edit.
   */
  liveTelemetry: {
    negotiateRoute: 'live/negotiate',
    hubName: 'telemetry',
    tickEvent: 'tick',
  },
};
